import React, {useCallback, useEffect, useRef, useState} from "react";
import {Card} from "react-bootstrap";
import Skeleton, {SkeletonTheme} from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import {useHistory, useLocation} from "react-router-dom";
import {PollApiCalls} from "../../apis/PollApiCalls";
import useMobileAccess from "../../hooks/useMobileAccess";
import {
    ACTION_HEADER,
    CREATE_POLL,
    MENU_LIST,
    DATE_HEADER,
    DEFAULT_ROWS_PER_PAGE,
    FEEDBACK_HEADER,
    FEEDBACK_KEY,
    GRADED_POLL,
    POLLS,
    POLL_KEY,
    POLL_SHARE_MODE_ACCESSOR,
    POLL_STATUS_HEADER,
    POLL_TITLE,
    POLL_TYPE,
    POLL_TYPE_ACCESSOR,
    POLL_TYPE_HEADER,
    QUESTION_HEADER,
    SURVEY,
    TEXTBOX,
    TITLE_HEADER,
    TOTAL_ATTENDANCES,
    TOTAL_GRADED,
    TOTAL_POLLS,
    TOTAL_QUESTIONS,
    UPDATED_DATE_PK,
    CREATE_ATTENDANCE_TEXT,
    CREATE_FIRST_ACTIVITY_TEXT,
    CREATE_FIRST_ACTIVITY_DESC,
} from "../../utils/constants";
import {getPollStatus, getPriority} from "../../utils/helpers";
import PublishModal from "../CreateQuizPage/PublishModal";
import styles from "./ManagePolls.module.css";
import PollSearchForm from "./PollSearchForm";
import PollTable from "./PollTable";
import {ReactComponent as NoResultImage} from "../../images/empty_activities_image.svg";
import {ReactComponent as ACTIVITY_ICON} from "./images/acitivity_icon.svg";
import {ReactComponent as POLL_ICON} from "./images/poll_icon.svg";
import {ReactComponent as ATTENDANCE_ICON} from "./images/attendance_icon.svg";
import YuJaButton from "../../components/standardization/YuJaButton";
import {useCardDistributor} from "../../hooks/useCardDistributor";
import {ReportApiCalls} from "../../apis/ReportApiCalls";
import {Button} from "@base-ui/react/button";

export default function ManagePollsPage(props) {
    const location = useLocation();
    let pollCode;
    let pollKey;
    if (location.state && location.state.pollCode) {
        pollCode = location.state.pollCode;
        pollKey = location.state.pollKey;
    }
    const [publishModalShow, setPublishModalShow] = useState(pollCode != undefined);
    const metricCardsContainerRef = useRef();
    let {maxCardsPerRow} = useCardDistributor(metricCardsContainerRef, 0, 210, 3, 15);

    const [filter, setFilter] = useState({});
    const [pollData, setPollData] = useState([]);
    const [pageIndex, setPageIndex] = useState(0);
    const [dataReady, setDataReady] = useState(false);
    const {getPollsFromUser} = PollApiCalls();
    const {warmUpBrowser} = ReportApiCalls();
    const history = useHistory();
    const [dateSort, setDateSort] = useState(0);
    const [titleSort, setTitleSort] = useState(1);
    const [modeSort, setModeSort] = useState(1);
    const [statusSort, setStatusSort] = useState(1);

    useEffect(() => {
        props.setPageIdentifier(MENU_LIST.ACTIVITIES.name);
    }, []);


    const sortDateHelper = () => {
        if (!!pollData) {
            if (dateSort === 0) {
                setPollData(
                    pollData
                        .sort(function (a, b) {
                            return new Date(Date.parse(a.updatedTimeSK)) - new Date(Date.parse(b.updatedTimeSK));
                        })
                );
                setDateSort(1);
            } else {
                setPollData(
                    pollData
                        .sort(function (a, b) {
                            return new Date(Date.parse(b.updatedTimeSK)) - new Date(Date.parse(a.updatedTimeSK));
                        })
                );
                setDateSort(0);
            }
        }
    }

    const sortTitleHelper = () => {
        if (!!pollData) {
            setPollData(pollData.sort(function (a, b) {
                const nameA = a.pollTitle?.toLowerCase();
                const nameB = b.pollTitle?.toLowerCase();

                const priorityA = getPriority(nameA);
                const priorityB = getPriority(nameB);

                if (priorityA < priorityB) return -1 * titleSort;
                if (priorityA > priorityB) return 1 * titleSort;

                if (nameA < nameB) return -1 * titleSort;
                if (nameA > nameB) return 1 * titleSort;
                return 0;
            }));
            setTitleSort(-titleSort);
        }
    }

    const sortModeHelper = () => {
        if (!!pollData) {
            setPollData(pollData.sort(function (a, b) {
                const nameA = a.pollType?.toLowerCase();
                const nameB = b.pollType?.toLowerCase();

                if (nameA < nameB) return -1 * modeSort;
                if (nameA > nameB) return 1 * modeSort;
                return 0;
            }));
            setModeSort(-modeSort);
        }
    }

    const sortStatusHelper = () => {
        if (!!pollData) {
            console.log(statusSort)
            setPollData(pollData.sort(function (a, b) {
                const nameA = getPollStatus(a).toLowerCase();
                const nameB = getPollStatus(b).toLowerCase();

                if (nameA < nameB) return -1 * statusSort;
                if (nameA > nameB) return 1 * statusSort;
                return 0;
            }));
            setStatusSort(-statusSort);
        }
    }


    const getPollInformation = async (pageIndex = 0) => {
        setDataReady(false);
        let res = await getPollsFromUser(true);
        res = res.filter(p => !!p.pollType && [GRADED_POLL, SURVEY, POLL_TYPE.ATTENDANCE, POLL_TYPE.MERGED_POLL].includes(p.pollType))
            .filter(p => p.isValid !== false)
            .sort((p1, p2) => Date.parse(p2.updatedTimeSK) - Date.parse(p1.updatedTimeSK));
        setPollData(res);
        setPageIndex(pageIndex);
        setDataReady(true);
    };

    useEffect(() => {
        warmUpBrowser("", "", "").then();
        getPollInformation();
    }, []);

    const handleSubmit = useCallback(({...filterObj}) => {
        setFilter(filterObj);
        setPageIndex(0);
    }, []);


    const isMobileScreen = useMobileAccess();

    const columns = [
        {Header: DATE_HEADER, accessor: UPDATED_DATE_PK, width: 130},
        {Header: TITLE_HEADER, accessor: POLL_TITLE, width: 250},
        {Header: POLL_TYPE_HEADER, accessor: POLL_TYPE_ACCESSOR, width: 110},
        {Header: QUESTION_HEADER, accessor: TOTAL_QUESTIONS, width: 100},
        // { Header: ACTIVATION_STATUS_HEADER, accessor: POLL_SORT_KEY, width: isMobileScreen ? 100 : 120 },
        {Header: POLL_STATUS_HEADER, accessor: POLL_SHARE_MODE_ACCESSOR, width: 190},
        {Header: FEEDBACK_HEADER, accessor: FEEDBACK_KEY, width: 90},
        {Header: ACTION_HEADER, accessor: POLL_KEY, width: 90, id: 'action'}
    ];

    const clickCreatePoll = () => {
        history.push({
            pathname: MENU_LIST.CREATE.path,
            state: {
                pollType: POLL_TYPE.MERGED_POLL,
                fromNavbar: true,
                previous: location.pathname
            }
        });
    };

    const clickCreateAttendance = () => {
        history.push({
            pathname: MENU_LIST.CREATE.path,
            state: {
                pollType: POLL_TYPE.ATTENDANCE,
                fromNavbar: true,
                previous: location.pathname
            }
        });
    };

    const clickOkay = () => {
        history.push(`/poll/share/${pollKey}/${pollCode.uniqueCode}`);
    };

    const clickHide = () => {
        setPublishModalShow(false);
        getPollInformation();
    };


    return (
        <>
            {typeof (pollCode) != "undefined" && (
                <PublishModal
                    show={publishModalShow}
                    setModalShow={setPublishModalShow}
                    pollCode={pollCode}
                    handleClickClose={clickHide}
                    handleClickOkay={clickOkay}
                    isGenerated={true}
                />
            )}
            {dataReady && pollData && pollData.length !== 0 && (
                <>
                    <div className={styles.container} id="manage-poll-page-container">
                        <div className={styles.titleCard}>
                            <div style={{display: "flex", flexDirection: "column", flex: 1, minWidth: 300}}>
                                <span className={styles.title}>{"Create a New Activity"}</span>
                                <span style={{height: 15}}/>
                                <span className={styles.description}>
                                    {"Get started with a new activity by creating a poll or attendance."}
                                </span>
                            </div>
                            <div style={{display: "flex", gap: 10}}>
                                <Button
                                    className={styles.navigateButton}
                                    onClick={() => clickCreatePoll()}
                                >{CREATE_POLL}</Button>
                                <Button
                                    className={styles.navigateButton}
                                    onClick={() => clickCreateAttendance()}
                                >{CREATE_ATTENDANCE_TEXT}</Button>
                            </div>
                        </div>


                        <div
                            className={styles.cardsContainer}
                            ref={metricCardsContainerRef}
                            style={{gridTemplateColumns: new Array(maxCardsPerRow).fill("minmax(0, 1fr)").join(" ")}}
                        >
                            <div className={styles.metricCard}>
                                <div className={styles.column} style={{flex: 1, minWidth: 80, height: "100%"}}>
                                    <div className={styles.regularLabel}>{TOTAL_POLLS}</div>
                                    <div style={{flex: 1}}/>
                                    <div className={styles.metric}>{pollData.length.toLocaleString()}</div>
                                </div>
                                <ACTIVITY_ICON style={{flexShrink: 0}}/>
                            </div>

                            <div className={styles.metricCard}>
                                <div className={styles.column} style={{flex: 1, minWidth: 80, height: "100%"}}>
                                    <div className={styles.regularLabel}>{TOTAL_GRADED}</div>
                                    <div style={{flex: 1}}/>
                                    <div className={styles.metric}>
                                        {pollData.filter(e => e.pollType !== POLL_TYPE.ATTENDANCE).length.toLocaleString()}
                                    </div>
                                </div>
                                <POLL_ICON style={{flexShrink: 0}}/>
                            </div>

                            <div className={styles.metricCard}>
                                <div className={styles.column} style={{flex: 1, minWidth: 80, height: "100%"}}>
                                    <div className={styles.regularLabel}>{TOTAL_ATTENDANCES}</div>
                                    <div style={{flex: 1}}/>
                                    <div className={styles.metric}>
                                        {pollData.filter(e => e.pollType === POLL_TYPE.ATTENDANCE).length.toLocaleString()}
                                    </div>
                                </div>
                                <ATTENDANCE_ICON style={{flexShrink: 0}}/>
                            </div>
                        </div>

                        <div className={styles.tableCardContainer}>
                            <div className={styles.cardContainerBody}>
                                <span className={styles.description}>{"Manage your poll and attendance activities."}</span>
                                <PollSearchForm handleSubmit={handleSubmit} collapsed={props?.collapsed}/>
                                <PollTable columns={columns} data={pollData} pageIdx={pageIndex} globalFilterObj={filter}
                                           getPollInformation={getPollInformation} Datesort={sortDateHelper} dateSort={dateSort}
                                           Titlesort={sortTitleHelper} Modesort={sortModeHelper} titleSort={titleSort}
                                           modeSort={modeSort} Statussort={sortStatusHelper} statusSort={statusSort}/>
                            </div>
                        </div>
                    </div>
                </>
            )}
            {dataReady && (!pollData || pollData.length === 0) && (
                <div
                    style={{flex: 1, minHeight: 0, width: "100%", padding: 20,}}
                >
                    <div
                        style={{
                            width: "100%", height: "100%", padding: 20,
                            border: "1px solid #EAECF0", borderRadius: 8, boxShadow: "0px 4px 8px -2px #1018281A",
                            display: "flex", flexDirection: "column", alignItems: "center", gap: 35,

                        }}
                    >
                        <span style={{flex: 1}}/>

                        {/*<div style={{width: 585, height: 332, position: "relative", display: "flex", alignItems: "center", justifyContent: "center"}}>*/}
                        {/*  <NoResultBG style={{position: "absolute", top: 0, left: 0, zIndex: -1,}}/>*/}
                        {/*  <NoResultImage/>*/}
                        {/*</div>*/}

                        <NoResultImage/>

                        <div style={{display: "flex", flexDirection: "column", alignItems: "center", gap: 20}}>
                            <div role={TEXTBOX}
                                 style={{fontSize: 20, fontWeight: "600"}}>{CREATE_FIRST_ACTIVITY_TEXT}</div>
                            <div role={TEXTBOX}
                                 style={{fontSize: 15, fontWeight: "400"}}>{CREATE_FIRST_ACTIVITY_DESC}</div>
                        </div>

                        <div style={{display: "flex", alignItems: "center", gap: 10}}>
                            <YuJaButton
                                style={{
                                    width: 165,
                                    height: 35,
                                    fontSize: 15,
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    whiteSpace: "nowrap"
                                }}
                                onClick={() => clickCreateAttendance()}
                            >
                                {CREATE_ATTENDANCE_TEXT}
                            </YuJaButton>
                            <YuJaButton
                                style={{
                                    width: 165,
                                    height: 35,
                                    fontSize: 15,
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    whiteSpace: "nowrap"
                                }}
                                onClick={() => clickCreatePoll()}
                            >
                                {CREATE_POLL}
                            </YuJaButton>
                        </div>

                        <span style={{flex: 2}}/>
                    </div>


                </div>
            )}
            {!dataReady && (
                <>
                    <div className={styles.container}>
                        <div className={styles.titleCard}>
                            <div style={{display: "flex", flexDirection: "column"}}>
                                <span className={styles.title}>{POLLS}</span>
                                <span style={{height: 15}}/>
                                <span className={styles.description}>
                                    {"View past activities you have created."}
                                </span>
                            </div>
                            <div style={{flex: 1}}/>
                            <div style={{display: "flex", gap: 10}}>
                                <Skeleton borderRadius={4} height={40} inline={true}
                                          width={160}
                                          className={styles.cardNumberSkeleton}
                                          containerClassName={styles.cardNumberSkeletonWrapper}
                                />
                                <Skeleton borderRadius={4} height={40} inline={true}
                                          width={160}
                                          className={styles.cardNumberSkeleton}
                                          containerClassName={styles.cardNumberSkeletonWrapper}
                                />
                            </div>
                        </div>
                        <div
                            className={styles.cardsContainer}
                            ref={metricCardsContainerRef}
                            style={{gridTemplateColumns: new Array(maxCardsPerRow).fill("minmax(0, 1fr)").join(" ")}}
                        >

                            <div className={styles.metricCard}>
                                <div className={styles.column} style={{flex: 1, minWidth: 80, height: "100%"}}>
                                    <Skeleton borderRadius={4} height={23} inline={true}
                                              width={120}
                                              containerClassName={styles.cardNumberSkeletonWrapper}
                                    />

                                    <div style={{flex: 1}}/>
                                    <Skeleton borderRadius={4} height={30} inline={true}
                                              width={50}
                                              containerClassName={styles.cardNumberSkeletonWrapper}
                                    />
                                </div>
                                <Skeleton borderRadius={4} height={48} inline={true}
                                          width={48}
                                          containerClassName={styles.cardNumberSkeletonWrapper}
                                          style={{flexShrink: 0}}
                                />
                            </div>

                            <div className={styles.metricCard}>
                                <div className={styles.column} style={{flex: 1, minWidth: 80, height: "100%"}}>
                                    <Skeleton borderRadius={4} height={23} inline={true}
                                              width={100}
                                              containerClassName={styles.cardNumberSkeletonWrapper}
                                    />
                                    <div style={{flex: 1}}/>
                                    <Skeleton borderRadius={4} height={30} inline={true}
                                              width={50}
                                              containerClassName={styles.cardNumberSkeletonWrapper}
                                    />
                                </div>
                                <Skeleton borderRadius={4} height={48} inline={true}
                                          width={48}
                                          containerClassName={styles.cardNumberSkeletonWrapper}
                                          style={{flexShrink: 0}}
                                />
                            </div>

                            <div className={styles.metricCard}>
                                <div className={styles.column} style={{flex: 1, minWidth: 80, height: "100%"}}>
                                    <Skeleton borderRadius={4} height={23} inline={true}
                                              width={150}
                                              containerClassName={styles.cardNumberSkeletonWrapper}
                                    />
                                    <div style={{flex: 1}}/>
                                    <Skeleton borderRadius={4} height={30} inline={true}
                                              width={50}
                                              containerClassName={styles.cardNumberSkeletonWrapper}
                                    />
                                </div>
                                <Skeleton borderRadius={4} height={48} inline={true}
                                          width={48}
                                          containerClassName={styles.cardNumberSkeletonWrapper}
                                          style={{flexShrink: 0}}
                                />
                            </div>
                        </div>

                        <div className={styles.tableCardContainer}>
                            <div className={styles.cardContainerHead}>{"Activities"}</div>
                            <div className={styles.cardContainerBody}>
                                <span className={styles.description}>{"View past activities you have created."}</span>
                                <div className={styles.skeletonTableContainer}>
                                    <SkeletonTheme color="rgba(237, 237, 237, 1)" highlightColor="lightgrey">
                                        <div className={styles.skeletonHeaderContainer}>

                                            <Skeleton borderRadius={10} height={20} inline={true} width="2vw"
                                                      containerClassName={styles.skeletonBodyCellWrapper}/>
                                            <Skeleton borderRadius={10} height={20} inline={true} width="6vw"
                                                      containerClassName={styles.skeletonBodyCellWrapper}/>
                                            <Skeleton borderRadius={10} height={20} inline={true} width="3vw"
                                                      containerClassName={styles.skeletonBodyCellWrapper}/>
                                            <Skeleton borderRadius={10} height={20} inline={true} width="3vw"
                                                      containerClassName={styles.skeletonBodyCellWrapper}/>
                                            <Skeleton borderRadius={10} height={20} inline={true} width="4vw"
                                                      containerClassName={styles.skeletonBodyCellWrapper}/>
                                            <Skeleton borderRadius={10} height={20} inline={true} width="2vw"
                                                      containerClassName={styles.skeletonBodyCellWrapper}/>
                                            <Skeleton borderRadius={10} height={20} inline={true} width="3vw"
                                                      className={styles.skeletonActionBodyCell}
                                                      containerClassName={styles.skeletonBodyCellWrapper}/>

                                        </div>
                                        <div className={styles.skeletonBodyContainer}>
                                            {Array.apply(null, Array(DEFAULT_ROWS_PER_PAGE)).map((_, idx) => {
                                                return (<div className={styles.skeletonBodyRow} key={idx}>
                                                    <Skeleton borderRadius={10} height={20} inline={true}
                                                              width={`${6 + Math.random()}vw`}
                                                              className={styles.skeletonBodyCell}
                                                              containerClassName={styles.skeletonBodyCellWrapper}/>
                                                    <Skeleton borderRadius={10} height={20} inline={true}
                                                              width={`${3 + (Math.random() * 7)}vw`}
                                                              className={styles.skeletonBodyCell}
                                                              containerClassName={styles.skeletonBodyCellWrapper}/>
                                                    <Skeleton borderRadius={10} height={20} inline={true}
                                                              width={`${idx % 2 === 0 ? 3.5 : 3}vw`}
                                                              className={styles.skeletonBodyCell}
                                                              containerClassName={styles.skeletonBodyCellWrapper}/>
                                                    <Skeleton borderRadius={10} height={20} inline={true}
                                                              width={`${1 + Math.random()}vw`}
                                                              className={styles.skeletonBodyCell}
                                                              containerClassName={styles.skeletonBodyCellWrapper}/>
                                                    <Skeleton borderRadius={10} height={20} inline={true}
                                                              width={`${2 + (Math.random() * 3)}vw`}
                                                              className={styles.skeletonBodyCell}
                                                              containerClassName={styles.skeletonBodyCellWrapper}/>
                                                    <Skeleton borderRadius={10} height={20} inline={true}
                                                              width={`${1 + (Math.random())}vw`}
                                                              className={styles.skeletonBodyCell}
                                                              containerClassName={styles.skeletonBodyCellWrapper}/>
                                                    <Skeleton borderRadius={10} height={20} inline={true} width="2vw"
                                                              className={styles.skeletonActionBodyCell}
                                                              containerClassName={styles.skeletonBodyCellWrapper}/>
                                                </div>)
                                            })}
                                        </div>
                                    </SkeletonTheme>
                                </div>
                            </div>
                        </div>

                    </div>
                </>
            )}
        </>
    );
}